export default () => (
  <div className="birthdayCard">
    <div className="cardFront">
      {/* Main text content */}
      <div className="card-content">
        <div className="header-text">
          <p className="happy-birthday">HAPPY BIRTHDAY</p>
          <p className="to-my">to my amazing</p>
        </div>
        
        <div className="wife-text-container">
          <h1 className="wife-script">Wife</h1>
        </div>
        
        <div className="heart-container">
          <img src="/images/heart-image.png" alt="heart" className="heart-img" />
        </div>
      </div>
    </div>
    <div className="cardInside">
      <p>Cynthia</p>
      <br />
      
      <p>
        I am so blessed to have shared another year on this earth with you. When I am with you, the rest of the world fades away.
      </p>
      <br />
      <p>
        You are always there for me and for our family. You give so much of yourself for all of us and we are truly so grateful. All your hard work and care for us does not go unnoticed. Thank you for all you do.
      </p>
        <br />
      <p>
        Wishing you a very happy birthday!
      </p>
      <br />
      <p>
        Love,
      </p>
      <p>
        Hubby, Theo and Ava
      </p>
      <p className="name">
        <img src="/images/heart-image.png" alt="heart" className="heart-signature" />
      </p>
    </div>
  </div>
);
